import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      return import(
        `../../frontend/assets/locales/${language}/${namespace}.json`
      ).catch(() => {
        console.error(
          '[i18n] could not load language/namespace in frontend/assets/locales',
          { language, namespace },
        )
      })
    }),
  )
  .init({
    supportedLngs: ['en', 'ja', 'ko'],
    ns: [],
    returnEmptyString: false,
    fallbackLng: 'en',
    defaultNS: false,
    // React already escapes anything it renders, so i18next escaping on top
    // double-encodes: a date interpolated into "Last Updated: {{date}}" came
    // out as "08&#x2F;12&#x2F;2025". Every interpolated value is rendered as
    // JSX text, never via dangerouslySetInnerHTML.
    interpolation: { escapeValue: false },
    detection: {
      order: [
        'querystring',
        'localStorage',
        // Disable navigator detection until we have properly translated login related components.
        // This is done to safely deploy https://github.com/disco-team/disco-apps/pull/5165
        // 'navigator',
      ],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
    },
  })

export default i18next
